import { cn } from '@crm/ui';
import type { LucideIcon } from 'lucide-react';

export interface FilterPill<T extends string> {
  key: T;
  label: string;
  icon: LucideIcon;
  /** Quantos itens o filtro traz - fica na propria pilula. */
  count?: number;
}

interface FilterPillsProps<T extends string> {
  options: readonly FilterPill<T>[];
  value: T;
  onChange: (value: T) => void;
  /** O que fecha a fila, como o botao de busca avancada. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * O corte que mais se usa numa fila de pilulas. Pilula, ao contrario dos
 * cartoes: aba se aperta, cartao se le. Do cartao ela pega so o contorno e a
 * sombra curta.
 */
export function FilterPills<T extends string>({
  options,
  value,
  onChange,
  children,
  className,
}: FilterPillsProps<T>) {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {options.map((option) => {
        const active = option.key === value;

        return (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={cn(
              'flex shrink-0 items-center gap-2 rounded-full border px-3 py-2 text-sm transition-colors',
              'shadow-[0_1px_2px_0_rgba(15,23,42,0.05),0_2px_6px_-2px_rgba(15,23,42,0.10)] dark:shadow-[0_1px_2px_0_rgba(0,0,0,0.5)]',
              active
                ? 'border-primary bg-primary/10 font-medium text-primary'
                : 'border-border-strong bg-card text-slate-600 hover:bg-muted dark:text-slate-300',
            )}
          >
            <option.icon className="h-4 w-4" />
            {option.label}
            {option.count === undefined ? null : (
              <span
                className={cn(
                  'rounded-full px-1.5 text-xs tabular-nums',
                  active ? 'bg-primary/15' : 'bg-muted',
                )}
              >
                {option.count}
              </span>
            )}
          </button>
        );
      })}

      {children}
    </div>
  );
}
